import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { PricingComparison } from './pages/PricingComparison';
import { CostGuide } from './pages/CostGuide';
import { TrackSpend } from './pages/TrackSpend';
import { Faq } from './pages/Faq';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit(); // Required for Magic Patterns canvas
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="compare" element={<PricingComparison data-id="element-7" />} data-id="element-6" />
          <Route path="guides/:tool" element={<CostGuide data-id="element-9" />} data-id="element-8" />
          <Route path="track-spend" element={<TrackSpend data-id="element-11" />} data-id="element-10" />
          <Route path="faq" element={<Faq data-id="element-13" />} data-id="element-12" />
        </Route>
      </Routes>
    </BrowserRouter>;
}